import service from '../services/cakeorders.service';
import { SendSms } from '../functions/SmsForm';
import { getStoreLabel } from '../constants/stores';
import { formatPhoneForSms } from './phone';

export async function getCakes() {
    return fetchCakesFromFirebase();
}

export async function fetchCakesFromFirebase() {
    // console.log('Fetching cakes from API');
    const cakes = await service.fetchCakes();
    localStorage.setItem('cakesData', JSON.stringify(cakes));
    return cakes;
}

export async function editCake(cake) {
    console.log('Editing cake:', cake);
    return await service.editCakeOrder(cake.id, cake);
}

export async function toggleImageReadiness(orderId, orderReady) {
    console.log('Toggling readiness for order', orderId);
    await service.toggleImageReadiness(orderId, orderReady);
}

export async function togglePrePaid(orderId, prePaid) {
    console.log('Toggling prePaid for order', orderId);
    await service.togglePrePaid(orderId, prePaid);
}

export async function clearCache() {
    localStorage.removeItem('cakesData');
}

// Phone number utilities have been moved to src/helpers/phone.js
// Re-export formatPhoneForSms for backward compatibility
export { formatPhoneForSms } from './phone';

export async function sendSmsConfirmation(order) {
    // Get store_id from order, or fallback to current user's store
    let storeId = order.store_id;
    if (!storeId) {
        try {
            storeId = await service.getUserStoreId();
        } catch (error) {
            console.warn('Could not get user store_id, using default', error);
        }
    }
    const storeAddress = getStoreLabel(storeId);
    const store = storeAddress && storeAddress !== 'Unassigned' ? storeAddress : 'Los Portales';
    
    const message = `${order.firstName}, pastel confirmado ${order.date}. ${store}`;

    const to = formatPhoneForSms(order.phoneNumber);
    console.log('Sending SMS to', to);
    try {
        await SendSms(to, message);
    } catch (error) {
        console.error('Error sending SMS', error);
        throw error;
    }
}

export async function sendSmsCakeReady(order) {
    // Get store_id from order, or fallback to current user's store
    let storeId = order.store_id;
    if (!storeId) {
        try {
            storeId = await service.getUserStoreId();
        } catch (error) {
            console.warn('Could not get user store_id, using default', error);
        }
    }
    const storeAddress = getStoreLabel(storeId);
    const store = storeAddress && storeAddress !== 'Unassigned' ? storeAddress : 'Los Portales';
    
    const message = `${order.firstName}, pastel listo! ${store}`;
    const to = formatPhoneForSms(order.phoneNumber);
    console.log('Sending SMS to:', to, 'with message:', message, 'for store:', store);
    try {
        await SendSms(to, message);
    } catch (error) {
        console.error('Failed to send SMS:', error);
        throw error; // Re-throw the error to be caught by the caller
    }
}

export const cakeDifferences = (cake1, cake2) => {
    const differences = {};
    for (const key in cake1) {
        if (cake1[key] !== cake2[key]) {
            differences[key] = cake2[key];
        }
    }
    return differences;
}